// @flow
import type {HttpService} from 'modules/common/services/http';
import type {TResponse} from 'types';

/**
 * Сервис для загрузки информации о игровых модулях
 */
export class TrainingModulesApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }

    /**
     * Получение списка игровых модулей
     * @param data ид пользователя
     * @return список игровых модулей
     */
    async getGameModules<T>(data: {userId: number | null}): TResponse<T> {
        return this._http.post<T>('/game-module', {
            body: data.userId ? data : undefined,
            extraOptions: {
                dataType: 'FORM_DATA',
                isPrivate: true,
            },
            options: {
                headers: {
                    'X-http-method-override': 'POST',
                },
            },
        });
    }

    /**
     * Получение пройденных разделов по id пользователя
     * @param userId id пользователя
     * @return список разделов
     */
    async getGameModuleChaptersByUserId<T>(userId: number | null): TResponse<T> {
        return this._http.post<T>('/game-modules/score', {
            body: {
                filter: {
                    userId,
                },
            },
            extraOptions: {
                isPrivate: true,
            },
            options: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-http-method-override': 'POST',
                },
            },
        });
    }

    /**
     * Получение списка игровых модулей
     * @param data ид пользователя
     * @return список игровых модулей
     */
    async startModule<T>(data: {gameModuleId: number}): TResponse<T> {
        return this._http.post<T>('/game-session/start', {
            body: data,
            extraOptions: {
                isPrivate: true,
            },
            options: {
                headers: {
                    'Content-Type': 'application/json',
                    'X-http-method-override': 'POST',
                },
            },
        });
    }
}
